module.exports = __webpack_public_path__ + "media/images/photos-a8235d6002d6f08bf62795412f264773.png";